import _Message from "@arco-design/web-react/es/Message";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { setItem } from '@src/utils/storage';
import TokenHistory from './tokenHistory';
var TextAreaDom = document.querySelector('.projectData');
var textAreaValue = {};
try {
  textAreaValue = JSON.parse(TextAreaDom.value);
} catch (_) {}
var saveLocal = function saveLocal(value) {
  setItem("theme-" + (textAreaValue.themeId || 0), value);
};
export var initState = {
  editTokens: {},
  savedTokens: textAreaValue.savedTokens || {},
  variables: {
    style: {},
    component: {}
  },
  tokenHistory: new TokenHistory()
};
var keyToToken;
export var getKeyToToken = function getKeyToToken(variables) {
  if ((!keyToToken || !Object.keys(keyToToken).length) && variables) {
    keyToToken = {};
    Object.keys(variables).forEach(function (type) {
      Object.keys(variables[type]).forEach(function (key) {
        variables[type][key].list.map(function (x) {
          keyToToken[x.key] = __assign(__assign({}, x), {
            component: key
          });
          if (key === 'Color') {
            keyToToken[x.key.replace('@color-', '@')] = __assign(__assign({}, x), {
              component: key
            });
            keyToToken[x.key.replace('@color-', '@dark-')] = __assign(__assign({}, x), {
              component: key
            });
          }
        });
      });
    });
  }
  return keyToToken;
};
function showTip(tokens) {
  var keyToToken = getKeyToToken();
  var list = Object.values(tokens).map(function (x) {
    var item = keyToToken[x.key];
    if (item) {
      return item.component + ": " + item.desc + " " + x.prevValue + " => " + x.value;
    }
  });
  _Message.info(list.join('\n'));
}
var reducers = function reducers(state, action) {
  if (state === void 0) {
    state = initState;
  }
  var tokenHistory = state.tokenHistory,
    variables = state.variables;
  var keyToToken = getKeyToToken(variables);
  var setEditToken = function setEditToken(data) {
    var newTokens = {};
    Object.values(data).map(function (x) {
      var _a, _b;
      var version = (_a = state.savedTokens[x.key]) === null || _a === void 0 ? void 0 : _a.version;
      newTokens[x.key] = __assign(__assign({}, x), {
        version: version || 0,
        desc: (_b = keyToToken[x.key]) === null || _b === void 0 ? void 0 : _b.desc
      });
    });
    saveLocal(__assign(__assign({}, state.editTokens), newTokens));
    return __assign(__assign({}, state), {
      editTokens: __assign(__assign({}, state.editTokens), newTokens)
    });
  };
  switch (action.type) {
    case 'setEditToken':
      {
        var data_1 = {};
        Object.values(action.payload).map(function (item) {
          var prevItem = state.editTokens[item.key] || state.savedTokens[item.key] || keyToToken[item.key];
          data_1[item.key] = __assign(__assign({}, item), {
            prevValue: prevItem && prevItem.value
          });
        });
        tokenHistory.add(data_1);
        return setEditToken(action.payload);
      }
    case 'updateSavedToken':
      {
        return __assign(__assign({}, state), {
          savedTokens: __assign(__assign({}, state.savedTokens), action.payload)
        });
      }
    case 'saveToken':
      {
        saveLocal({});
        return __assign(__assign({}, state), {
          editTokens: {},
          savedTokens: __assign(__assign(__assign({}, state.savedTokens), state.editTokens), action.payload)
        });
      }
    case 'resetTokens':
      {
        saveLocal({});
        var payload_1 = action.payload;
        if ('keys' in payload_1 && payload_1.keys) {
          var data_2 = {};
          Object.values(payload_1.keys).map(function (key) {
            var _a;
            var item = state.editTokens[key] || state.savedTokens[key];
            if (item) {
              data_2[key] = __assign(__assign({}, item), {
                prevValue: item.value,
                value: (_a = (payload_1.tokens || state.savedTokens)[key]) === null || _a === void 0 ? void 0 : _a.value
              });
            }
            tokenHistory.add(data_2);
          });
        } else if ('component' in payload_1) {
          tokenHistory.clear(payload_1.component);
        }
        return __assign(__assign({}, state), {
          savedTokens: payload_1.tokens || state.savedTokens,
          editTokens: {}
        });
      }
    case 'tokenBack':
      {
        var tokens = tokenHistory.back(action.payload);
        if (tokens) {
          showTip(tokens);
          return setEditToken(tokens);
        }
      }
      return state;
    case 'tokenForward':
      {
        var tokens = tokenHistory.forward(action.payload);
        if (tokens) {
          showTip(tokens);
          return setEditToken(tokens);
        }
      }
      return state;
    default:
      return state;
  }
};
export default reducers;